import axios from 'axios';
import {env} from '../env';
import {navigate} from "../navigation/navigationHistory";

export let tokenStorage = localStorage;

const baseUrl = env.apiBaseUrl;

let baseConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};


const prefixedURL = `${baseUrl}/coreapi/v5`;
export const api = axios.create({
  baseURL: prefixedURL,
  ...baseConfig
});

export const anonApi = axios.create({
  baseURL: prefixedURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export const apiAbs = axios.create({
  baseURL: baseUrl,
  ...baseConfig
});

function getCurrentToken() {
  return localStorage.getItem('token') || null;
}

function setCurrentToken(token) {
  if (token === null) {
    tokenStorage.removeItem('token')
  } else {
    tokenStorage.setItem('token', token);
  }
}

let waitingQueue = null;

function getToken() {
  const currentToken = getCurrentToken();
  if (currentToken) {
    return Promise.resolve(currentToken);
  } else {
    if (waitingQueue === null) {
      waitingQueue = [];
      return anonApi.post('/clients/ConsumerSalesPortal/sessions').then(res => {
        const jwtToken = res.data.jwtToken || null;
        setCurrentToken(jwtToken);
        waitingQueue.forEach(onJwt => onJwt(jwtToken));
        waitingQueue = null;
        return jwtToken
      }).catch(err => {
        console.log(err);
        setCurrentToken(null);
        waitingQueue.forEach(onJwt => onJwt(null));
        waitingQueue = null;
        err._jwtInitiation = true;
        throw err;
      })
    } else {
      return new Promise((resolve, reject) => {
        waitingQueue.push(token => {
          if (token === null) {
            reject(token);
          } else {
            resolve(token);
          }
        })
      });
    }
  }
}

function attachInterceptor(instance) {
  instance.interceptors.request.use((config) => {
    return getToken().then((token) => {
      if (!token) {
        throw new Error('no jwt, request canceled ' + config.method + ' ' + config.url);
      }
      config.headers.Authorization = 'Bearer ' + token;
      return Promise.resolve(config);
    })
  }, (error) => {
    console.log("Unable to get security token: " + (error.response ? error.response.status : error.message));
    return Promise.reject(error);
  });

  //handling expired tokens
  instance.interceptors.response.use(response => response,
    error => {
      const originalRequest = error.config;
      const statusCode = (error.response ? error.response.status : 0);
      if (statusCode === 401 && !error._jwtInitiation && !originalRequest._retry) {

        console.log('session expired, retrying');

        //invalidate current token
        setCurrentToken(null);
        originalRequest._retry = true;
        return getToken().then((token) => {
          if (!token) {
            throw new Error('no jwt, request canceled ' + originalRequest.method + ' ' + originalRequest.url);
          }
          originalRequest.headers.Authorization = 'Bearer ' + token;
          return axios(originalRequest);
        })
      } else if (statusCode === 503) {
        console.log('Server detected in maintenance mode.  Redirecting to offline advisory.');
        Promise.reject(error);
        navigate('/server-maintenance');
      } else {
        return Promise.reject(error);
      }
    });
}

attachInterceptor(api);
attachInterceptor(apiAbs);
